import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Icon from '@space-core/components/icon'
import styled from 'styled-components'

type Props = {
  onClick(): void
}

const Container = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  background-color: rgba(14, 16, 18, 0.8);
`

const WindowCloseIcon = ({ onClick }: Props) => {
  return (
    <Container
      onClick={onClick}
      className='_rounded-circle _d-flex _align-items-center _justify-content-center _shadow-sm'>
      <Icon icon={faXmark} aria-hidden className='_text-3 _text-white' />
    </Container>
  )
}

export default WindowCloseIcon
